import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import styles from "./FloorMapping.module.css"; // Importing the updated module.css file
import cssClasses from "../Allotments/Allotments.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";
import { getTokenServerTime } from "../../Services/Tokens";

import { errorTost } from "../../Services/Toast";

const FloorMappingNew = () => {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
   const [dialogMessage, setDialogMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { data, paymentId, tokenNo } = location.state || {};
  //  const [data,setData]=useState([]);
  const [floorsWithUnitCount, setFloorsWithUnitCount] = useState([]);
  const [maxFloor, setMaxFloor] = useState(0);
  const [priceRanges, setPriceRanges] = useState({
    floor1to3: { min: 0, max: 0, avg: 0 },
    floor4to7: { min: 0, max: 0, avg: 0 },
    floor8to16: { min: 0, max: 0, avg: 0 },
    floorAbove16: { min: 0, max: 0, avg: 0 },
  });
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  // 🔹 Function to fetch data (reusable)
  // const fetchUnits = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getAllUnitsFromLaunchesForCustomerFastBooking`
  //     );

  //     if (res.data?.data) {
  //       setData(res.data.data); // store in state
  //     }
  //   } catch (error) {
  //     console.error("Error fetching units:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // 🔹 useEffect to call API when component mounts
  // useEffect(() => {
  //   fetchUnits(); // auto-fetch on mount
  // }, []);

  useEffect(() => {
    // Update screen size on window resize
    const updateScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 600); // Check if screen width is 600px or less
    };

    // Add event listener for window resize
    window.addEventListener("resize", updateScreenSize);

    // Check initial screen size
    updateScreenSize();

    return () => {
      window.removeEventListener("resize", updateScreenSize); // Clean up event listener on component unmount
    };
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      const floorMap = {};
      let highestFloor = 0;

      // Group units by floor and track the highest floor number
      data.forEach((unit) => {
        const floorNo = unit.unitId?.floorNo;
        if (floorNo) {
          if (!floorMap[floorNo]) floorMap[floorNo] = [];
          floorMap[floorNo].push(unit);

          const floorNumber = parseInt(floorNo.replace("FLOOR ", ""), 10);
          highestFloor = Math.max(highestFloor, floorNumber);
        }
      });
      setMaxFloor(highestFloor);

      // Build floor-wise data
      const floorsWithCount = Object.keys(floorMap).map((floorNo) => {
        const units = floorMap[floorNo];

        // ✅ Separate available and sold units
        const availableUnits = units.filter(
          (u) =>
            u.unitId?.inventoryStatusId ===
            "91c9faab-5adc-4b2f-a36e-b19160049413"
        );
        const soldUnits = units.filter(
          (u) =>
            u.unitId?.inventoryStatusId !==
            "91c9faab-5adc-4b2f-a36e-b19160049413"
        );

        const totalCost = units.reduce(
          (sum, unit) => sum + unit.unitId.totalCost,
          0
        );
        const avgCost = totalCost / units.length;

        return {
          floorNo,
          availableCount: availableUnits.length, // ✅ Available count
          soldCount: soldUnits.length, // ✅ Sold count
          units,
          availableUnits,
          totalCost,
          avgCost,
        };
      });

      // Sort by descending floor number
      const sortedFloors = floorsWithCount.sort((a, b) => {
        const floorANumber = parseInt(a.floorNo.replace("FLOOR ", ""), 10);
        const floorBNumber = parseInt(b.floorNo.replace("FLOOR ", ""), 10);
        return floorBNumber - floorANumber;
      });

      setFloorsWithUnitCount(sortedFloors);

      // Calculate price ranges based on the available floors
      calculatePriceRanges(sortedFloors);
    }
  }, [data]);

  // 🔹 UPDATED calculatePriceRanges — counts only available units
  const calculatePriceRanges = (floorsWithCount) => {
    let priceRanges = {
      floor1to3: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floor4to7: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floor8to16: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floorAbove16: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
    };

    floorsWithCount.forEach((floor) => {
      const floorNumber = parseInt(floor.floorNo.replace("FLOOR ", ""), 10);
      const priceInLacs = floor.avgCost / 100000;

      // 🔹 Count only available units
      const availableUnitCount = floor.availableUnits?.length || 0;

      if (floorNumber >= 1 && floorNumber <= 3) {
        priceRanges.floor1to3.min = Math.min(
          priceRanges.floor1to3.min,
          priceInLacs
        );
        priceRanges.floor1to3.max = Math.max(
          priceRanges.floor1to3.max,
          priceInLacs
        );
        priceRanges.floor1to3.avg += priceInLacs;
        priceRanges.floor1to3.unitCount += availableUnitCount;
      } else if (floorNumber >= 4 && floorNumber <= 7) {
        priceRanges.floor4to7.min = Math.min(
          priceRanges.floor4to7.min,
          priceInLacs
        );
        priceRanges.floor4to7.max = Math.max(
          priceRanges.floor4to7.max,
          priceInLacs
        );
        priceRanges.floor4to7.avg += priceInLacs;
        priceRanges.floor4to7.unitCount += availableUnitCount;
      } else if (floorNumber >= 8 && floorNumber <= 17) {
        priceRanges.floor8to16.min = Math.min(
          priceRanges.floor8to16.min,
          priceInLacs
        );
        priceRanges.floor8to16.max = Math.max(
          priceRanges.floor8to16.max,
          priceInLacs
        );
        priceRanges.floor8to16.avg += priceInLacs;
        priceRanges.floor8to16.unitCount += availableUnitCount;
      } else if (floorNumber > 17) {
        priceRanges.floorAbove16.min = Math.min(
          priceRanges.floorAbove16.min,
          priceInLacs
        );
        priceRanges.floorAbove16.max = Math.max(
          priceRanges.floorAbove16.max,
          priceInLacs
        );
        priceRanges.floorAbove16.avg += priceInLacs;
        priceRanges.floorAbove16.unitCount += availableUnitCount;
      }
    });

    // Count floors for averaging
    const floorCounts = {
      floor1to3: floorsWithCount.filter(
        (f) => parseInt(f.floorNo.replace("FLOOR ", "")) <= 3
      ).length,
      floor4to7: floorsWithCount.filter((f) => {
        const n = parseInt(f.floorNo.replace("FLOOR ", ""));
        return n >= 4 && n <= 7;
      }).length,
      floor8to16: floorsWithCount.filter((f) => {
        const n = parseInt(f.floorNo.replace("FLOOR ", ""));
        return n >= 8 && n <= 16;
      }).length,
      floorAbove16: floorsWithCount.filter(
        (f) => parseInt(f.floorNo.replace("FLOOR ", "")) > 16
      ).length,
    };

    Object.keys(priceRanges).forEach((key) => {
      const count = floorCounts[key];
      if (count > 0) priceRanges[key].avg /= count;
    });

    setPriceRanges(priceRanges);
  };

  const getFloorBackgroundColor = (floorNo) => {
    const floorNumber = parseInt(floorNo.replace("FLOOR ", ""), 10);

    if (floorNumber >= 1 && floorNumber <= 3) return "#ffffff"; // Floors 1-2
    if (floorNumber >= 4 && floorNumber <= 7) return "#d6d6d6"; // Floors 3-8
    if (floorNumber >= 8 && floorNumber <= 16) return "#ffffff"; // Floors 9-10
    if (floorNumber >= 17 && floorNumber <= 22) return "#d6d6d6"; // Floors 12-18

    return "#fff"; // Default color for other floors (if any)
  };
  const getFloorLabel = (floorNo) => {
    const floorNumber = parseInt(floorNo.replace("FLOOR ", ""), 10);

    if (floorNumber === 1) return `${floorNumber}`;
    if (floorNumber === 2) return `${floorNumber}`;
    if (floorNumber === 3) return `${floorNumber}`;

    return `${floorNumber}`; // Default case for 4th, 5th, etc.
  };

  // const handleFloorClick = (floorData) => {
  //   console.log("FloorMapping floorData", floorData);
  //     navigate("/Home/UnitSelection", {
  //       state: { floorData,paymentId ,tokenNo}, // Pass full floor data including units

  //     });
  //     console.log('paymentId', paymentId)
  // };

  // const handleFloorClick = async (floorData) => {
  //   try {
  //     setLoading(true);

  //     console.log(" FloorMapping Clicked Floor Data:", floorData);

  //     // 1️⃣ Fetch server time
  //     const serverResp = await getTokenServerTime();
  //     const serverTime = serverResp?.data?.currentTime;
  //     console.log("⏱ Server Time (ms):", serverTime);

  //     // 2️⃣ Extract IDs dynamically
  //     const firstUnit = floorData?.availableUnits?.[0];
  //     const eventId =
  //       firstUnit?.launchId?.eventId?.eventId

  //     const launchId =
  //       firstUnit?.launchId?.launchId ||
  //       floorData?.availableUnits?.[0]?.launchId.launchId

  //     //  Log all the dynamic IDs
  //     console.log("📘 Extracted IDs:");
  //     console.log("   🔹 eventId:", eventId);

  //     console.log("   🔹 launchId:", launchId);

  //     // 🔸 Validate IDs
  //     if (!eventId || !launchId) {
  //       console.error("❌ Missing one or more IDs! Cannot continue.");
  //       errorTost("Missing event details. Please try again.");
  //       setLoading(false);
  //       return;
  //     }

  //     // 3️⃣ Build request body
  //     const body = { eventId,  launchId };

  //     // 4️⃣ API call to get booking config
  //     const resp = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getEventOnlineBookingConfigDetails`,
  //       body
  //     );

  //     const config = resp?.data?.data;
  //     console.log("📥 Booking Config Response:", config);

  //     if (!config) {
  //       errorTost("Unable to fetch booking configuration.");
  //       setLoading(false);
  //       return;
  //     }

  //     const { isOnlineBookingAccept, endDate } = config;
  //     console.log("✅ isOnlineBookingAccept:", isOnlineBookingAccept);
  //     console.log("✅ endDate:", endDate, "| ServerTime:", serverTime);

  //     // 5️⃣ Compare server time and booking status
  //     if (isOnlineBookingAccept && serverTime <= endDate) {
  //       console.log("🎉 Booking active — navigating to UnitSelection...");
  //       navigate("/Home/UnitSelection", {
  //         state: { floorData, paymentId, tokenNo },
  //       });
  //     } else {
  //       console.warn("⚠️ Booking ended or disabled.");
  //       errorTost("Online booking has ended or is not available currently.");
  //     }
  //   } catch (error) {
  //     console.error("💥 Error in handleFloorClick:", error);
  //     errorTost("Something went wrong while checking booking availability.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCloseDialog = () => setOpenDialog(false);

  const handleFloorClick = async (floorData) => {
    try {
      setLoading(true);

      // 1️⃣ Fetch server time
      const serverResp = await getTokenServerTime();
      const serverTime = serverResp?.data?.currentTime;

      // 2️⃣ Extract IDs dynamically
      const firstUnit = floorData?.availableUnits?.[0];
      const eventId = firstUnit?.launchId?.eventId?.eventId;
      const launchId = firstUnit?.launchId?.launchId;

      if (!eventId || !launchId) {
        setDialogMessage("No units are available on this floor. Please select a different floor.");
        setOpenDialog(true);
        setLoading(false);
        return;
      }

      // 3️⃣ Build request body
      const body = { eventId, launchId };

      // 4️⃣ API call
      const resp = await axios.post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getEventOnlineBookingConfigDetails`,
        body
      );

      const config = resp?.data?.data;

      if (!config) {
        setDialogMessage("Unable to fetch booking configuration. Please try again later.");
        setOpenDialog(true);
        setLoading(false);
        return;
      }

      const { isOnlineBookingAccept, endDate } = config;

      // 5️⃣ Validation logic
      if (isOnlineBookingAccept && serverTime <= endDate) {
        navigate("/Home/UnitSelection", {
          state: { floorData, paymentId, tokenNo },
        });
      } else {
        console.warn("⚠️ Booking ended or disabled.");
        setDialogMessage("Online booking has ended or is not available currently.");
        setOpenDialog(true);
      }
    } catch (error) {
      console.error("💥 Error in handleFloorClick:", error);
      setDialogMessage("Something went wrong while checking booking availability.");
      setOpenDialog(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <CircularProgress size={22} sx={{ color: "white" }} />
      ) : (
        <div className={cssClasses.wrapperTargetPage}>
          <Box
            onClick={() => navigate("/Home/Tokens")}
            sx={{
              display: "inline-block",
              fontSize: { xs: 12, sm: 14 },
              fontWeight: 600,
              textTransform: "uppercase",
              background: "linear-gradient(90deg, #0072ff 0%, #00b4e6ff 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              cursor: "pointer",
              position: "relative",
              letterSpacing: 0.5,
              "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                bottom: -3,
                width: "100%",
                height: 2,
                background: "linear-gradient(90deg, #0072ff, #00b4e6ff)",
                transform: "scaleX(0)",
                transformOrigin: "right",
                transition: "transform 0.3s ease",
              },
              "&:hover::after": {
                transform: "scaleX(1)",
                transformOrigin: "left",
              },
            }}
          >
            ← Go Back To Token
          </Box>
          <div className={cssClasses.mainContent}>
            <div className={cssClasses.headerMainContent}>
              <div className={cssClasses.wrapperHeader}>
                <div
                  className={cssClasses.wrapperTitleUserName}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div
                    className={cssClasses.headerTitle}
                    style={{
                      fontWeight: "bold",
                      fontSize: isSmallScreen ? "20px" : "",
                      transform: isSmallScreen ? "translateX(70%)" : "none",
                    }}
                  >
                    Pick Your Floor
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                alignItems: "center",
                backgroundColor: "white",
                paddingTop: "15px",
                paddingBottom: "15px",
                height: "auto", // Allow height to adjust based on content
                maxHeight: "70vh", // Set max height to make it scrollable
                overflowY: "auto", // Enable scrolling when content overflows
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <div
                  className={styles.floorMapContainer}
                  style={{
                    alignItems: "center",
                    flexDirection: "column-reverse",
                  }}
                >
                  {/* Rendering Basement Levels */}
                  {["Basement 3", "Basement 2", "Basement 1"].map(
                    (floor, index) => (
                      <div
                        key={index}
                        className={styles.basement}
                        style={{
                          border: "1px solid black",
                          width: isSmallScreen ? "300px" : "",
                          height: "30px",
                          transform: isSmallScreen ? "translateX(14.4%)" : " ",
                        }}
                      >
                        <div
                          className={styles.floorLabel}
                          style={{
                            textAlign: "start",
                            paddingLeft: "5px",
                            paddingTop: "5px",
                          }}
                        >
                          {floor}
                        </div>
                      </div>
                    )
                  )}

                  {/* Rendering Ground Floor */}
                  <div
                    style={{
                      width: isSmallScreen ? "270px" : "450px",
                      height: "30px",
                      display: "flex",
                      flexDirection: "row",
                      transform: isSmallScreen
                        ? "translateX(10%)"
                        : "translateX(-5.5%)",
                    }}
                  >
                    <div
                      className={styles.groundFloor}
                      style={{
                        textAlign: "start",
                        paddingLeft: "5px",
                        paddingTop: "5px",
                      }}
                    >
                      <div className={styles.floorLabel}>GROUND</div>

                      <div className={styles.groundFloorLine} />
                    </div>
                    <div className={styles.groundFloor}></div>
                  </div>

                  {/* 🔹 TERRACE Label Only */}
                  {/*Rendering floor 1*/}
                  <div
                    style={{
                      width: isSmallScreen ? "270px" : "450px",
                      height: "30px",
                      display: "flex",
                      flexDirection: "row",
                      transform: isSmallScreen
                        ? "translateX(10%)"
                        : "translateX(-5.5%)",
                    }}
                  >
                    <div
                      className={styles.groundFloor}
                      style={{
                        textAlign: "start",
                        paddingLeft: "5px",
                        paddingTop: "5px",
                      }}
                    >
                      <div className={styles.floorLabel}>FLOOR 1</div>

                      <div className={styles.groundFloorLine} />
                    </div>
                    <div className={styles.groundFloor}></div>
                  </div>

                  {/*Rendering Floor 2 */}
                  <div
                    className={styles.groundFloor}
                    style={{
                      width: isSmallScreen ? "228px" : "306px",
                      transform: isSmallScreen
                        ? "translateX(20.5%)"
                        : "translateX(15.3%)",
                      height: "30px",
                    }}
                  >
                    <div
                      className={styles.floorLabel}
                      style={{
                        textAlign: "start",
                        paddingLeft: "5px",
                        paddingTop: "5px",
                      }}
                    >
                      2
                    </div>
                    <div className={styles.groundFloorLine} />
                  </div>

                  {/* Rendering Other Floors in Descending Order */}
                  {Array.from({ length: maxFloor }, (_, index) => {
                    const floorNo = `FLOOR ${index + 1}`;
                    const floorLabel = getFloorLabel(floorNo);
                    const floor = floorsWithUnitCount.find(
                      (f) => f.floorNo === floorNo
                    );
                    const isNonClickable =
                      floorNo === "FLOOR 1" ||
                      floorNo === "FLOOR 2" ||
                      floorNo === "FLOOR 3";
                    const isMissing = !floor;
                    if (floorNo === "FLOOR 1" || floorNo === "FLOOR 2") {
                      return null;
                    }
                    return (
                      <>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div
                            style={{
                              alignItems: "center",
                              paddingRight: "3px",
                              marginTop: "9px",
                              fontSize: "13px",
                            }}
                          >
                            FLOOR
                          </div>
                          <div
                            key={index}
                            className={`${styles.floor} ${
                              isNonClickable ? styles.nonClickable : ""
                            }`}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              backgroundColor: isMissing
                                ? "#d3d3d3" // Gray out missing floors
                                : getFloorBackgroundColor(floorNo),
                              opacity: isMissing ? 0.6 : 1,
                              cursor:
                                isMissing || isNonClickable
                                  ? "default"
                                  : "pointer", // Add pointer cursor on click
                              transition: isNonClickable
                                ? "none"
                                : "background-color 0.3s ease, transform 0.3s ease", // Smooth transition
                            }}
                            onClick={() => {
                              if (!isMissing && !isNonClickable)
                                handleFloorClick(floor);
                            }} // Pass the full floor data
                          >
                            <div className={styles.floorLabel}>
                              <span>{floorLabel} </span>
                            </div>
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              {floorNo !== "FLOOR 2" &&
                                floorNo !== "FLOOR 3" &&
                                floorNo !== "FLOOR 1" && (
                                  <>
                                    <div
                                      style={{
                                        backgroundColor: "#509401",
                                        marginRight: "15px",
                                        width: "22px",
                                        borderRadius: "3px",
                                        padding: "1px 3px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        color: "white",
                                        textAlign: "center",
                                      }}
                                    >
                                      {(floor?.availableCount ?? 0)
                                        .toString()
                                        .padStart(2, "0")}{" "}
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "#bf130d",
                                        borderRadius: "3px",
                                        width: "22px",
                                        padding: "1px 3px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        color: "white",
                                        textAlign: "center",
                                      }}
                                    >
                                      {(floor?.soldCount ?? 0)
                                        .toString()
                                        .padStart(2, "0")}
                                    </div>
                                  </>
                                )}{" "}
                            </div>
                          </div>
                          {/* -{" "}
                      {isMissing
                        ? "No Units Available"
                        : floor.unitCount + " Units"} */}
                        </div>
                      </>
                    );
                  })}
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: isSmallScreen ? "160px" : "240px",
                      marginLeft: isSmallScreen ? "15px" : "35px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                      TERRACE
                    </span>
                    <span style={{ display: "flex" }}>
                      <span
                        style={{
                          width: "50px",
                          fontSize: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        UNITS AVAILABLE
                      </span>
                      <span
                        style={{
                          width: "25px",
                          fontSize: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        UNITS SOLD
                      </span>
                    </span>
                  </span>
                </div>

                {/* Price Range Indicators - Add this after floorMapContainer closing div */}
                {/* main ui for price range first div for whole block */}
                <div
                  style={{
                    position: "relative",
                    width: isSmallScreen ? "160px" : "200px",
                    marginLeft: isSmallScreen ? "0px" : "0px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    paddingBottom: "0px", // Adjust based on basement height
                    transform: isSmallScreen
                      ? "translateX(-55%)translateY(4%)"
                      : "translateX(-50%)translateY(4%)",
                  }}
                >
                  {/* Floors 16-22 */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: isSmallScreen ? "190px" : "180px", // Height for 6 floors
                      marginBottom: "0px",
                    }}
                  >
                    <svg
                      width={isSmallScreen ? "100px" : "150"}
                      height={isSmallScreen ? "180px" : "170px"}
                      viewBox="0 0 40 150"
                      style={{ marginRight: "10px", position: "absolute" }}
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M 3 0 
       L 25 0 
       L 25 75 
       L 25 75 
       L 25 75 
       L 25 150 
       L 3 150"
                        fill="none"
                        stroke="#999"
                        strokeWidth="1"
                      />
                    </svg>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid black",
                        backgroundColor: "#d6d6d6",
                        padding: isSmallScreen ? "5px 10px" : "5px 15px",
                        textAlign: "center",
                        marginLeft: "25px",
                        zIndex: "999",
                      }}
                    >
                      <span style={{ fontSize: "7px" }}>PRICE RANGE</span>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: isSmallScreen ? "11px" : "14px",
                        }}
                      >
                        {priceRanges.floorAbove16.min !== Infinity
                          ? `${priceRanges.floorAbove16.min.toFixed(
                              2
                            )}L – ${priceRanges.floorAbove16.max.toFixed(2)}L`
                          : " "}
                        <br />
                        {/* <span style={{ fontWeight: "normal", fontSize:isSmallScreen?"12px":  "14px", color: "#277037ff" }}>
    {priceRanges.floorAbove16.unitCount} Units Available
  </span> */}
                      </span>
                    </div>
                  </div>

                  {/* Floors 8-18 */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: isSmallScreen ? "285px" : "270px", // Height for 9 floors
                      marginBottom: "0px",
                    }}
                  >
                    <svg
                      width={isSmallScreen ? "100px" : "150"}
                      height={isSmallScreen ? "280px" : "260px"}
                      viewBox="0 0 40 150"
                      style={{ marginRight: "10px", position: "absolute" }}
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M 3 0 
       L 25 0 
       L 25 75 
       L 25 75 
       L 25 75 
       L 25 150 
       L 3 150"
                        fill="none"
                        stroke="#999"
                        strokeWidth="1"
                      />
                    </svg>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid black",
                        backgroundColor: "#fff",
                        padding: isSmallScreen ? "5px 10px" : "5px 15px",
                        textAlign: "center",
                        marginLeft: "25px",
                        zIndex: "999",
                      }}
                    >
                      <span style={{ fontSize: "7px" }}>PRICE RANGE</span>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: isSmallScreen ? "11px" : "14px",
                        }}
                      >
                        {priceRanges.floor8to16.min !== Infinity
                          ? `${priceRanges.floor8to16.min.toFixed(
                              2
                            )}L – ${priceRanges.floor8to16.max.toFixed(2)}L`
                          : " "}
                        <br />
                        {/* <span style={{ fontWeight: "normal", fontSize: isSmallScreen?"12px": "14px", color: "#277037ff" }}>
    {priceRanges.floor8to16.unitCount} Units Available
  </span> */}
                      </span>
                    </div>
                  </div>

                  {/* Floors 3-8 */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: isSmallScreen ? "130px" : "120px", // Height for 4 floors
                      marginBottom: "0px",
                    }}
                  >
                    <svg
                      width={isSmallScreen ? "100px" : "150"}
                      height={isSmallScreen ? "120px" : "110px"}
                      viewBox="0 0 40 150"
                      style={{ marginRight: "10px", position: "absolute" }}
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M 3 0 
       L 25 0 
       L 25 75 
       L 25 75 
       L 25 75 
       L 25 150 
       L 3 150"
                        fill="none"
                        stroke="#999"
                        strokeWidth="1"
                      />
                    </svg>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid black",
                        backgroundColor: "#d6d6d6",
                        padding: isSmallScreen ? "5px 10px" : "5px 15px",
                        textAlign: "center",
                        zIndex: "999",
                        marginLeft: "25px",
                      }}
                    >
                      <span style={{ fontSize: "7px" }}>PRICE RANGE</span>

                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: isSmallScreen ? "11px" : "14px",
                        }}
                      >
                        {priceRanges.floor4to7.min !== Infinity
                          ? `${priceRanges.floor4to7.min.toFixed(
                              2
                            )}L – ${priceRanges.floor4to7.max.toFixed(2)}L`
                          : "40–50 Lacs"}
                        <br />
                        {/* <span style={{ fontWeight: "normal", fontSize:isSmallScreen?"12px":  "14px", color: "#277037ff" }}>
    {priceRanges.floor4to7.unitCount} Units Available
  </span> */}
                      </span>
                    </div>
                  </div>

                  {/* Floors 1-3 */}
                  {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "90px", // Height for 6 floors
                  marginBottom: "0px",
                }}
              >
               <svg
        width="40"
        height={ isSmallScreen ? "80px" : "80px"}
        viewBox="0 0 40 150"
        style={{ marginRight: '10px' }}
        preserveAspectRatio="none"
      >
        <path
          d="M 5 0 Q 20 0, 25 15 L 25 50 Q 25 75, 40 75 Q 25 75, 25 90 L 25 135 Q 20 150, 5 150"
          fill="none"
          stroke="#999"
          strokeWidth="4"
        />
      </svg>
                  <span style={{ fontWeight: "bold", fontSize:isSmallScreen?"12px":  "14px" }}>
  {priceRanges.floor1to3.min !== Infinity
    ? `₹${priceRanges.floor1to3.min.toFixed(0)}–${priceRanges.floor1to3.max.toFixed(0)} Lacs`
    : "40–50 Lacs"}
  <br />
  <span style={{ fontWeight: "normal", fontSize:isSmallScreen?"12px": "14px", color: "#277037ff" }}>
    {priceRanges.floor1to3.unitCount} Units Available
  </span>
</span>
              
              </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

 <Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  fullWidth
  maxWidth="sm"
  PaperProps={{
    sx: {
      borderRadius: "10px",
      border: "1px solid #1976d2",
      maxWidth: "400px",
      width: "90%",
      mx: "auto",
      overflow: "hidden",
      "@media (max-width:600px)": {
        width: "95%", // shrink slightly on mobile
        maxWidth: "none", // removes fixed width cap
        margin: "10px",
      },
    },
  }}
>
  <DialogContent
    sx={{
      padding: "16px 24px",
      fontSize: "1.6rem",
      color: "#333",
      lineHeight: "1.8",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "stretch",
      overflow: "visible", // ensure no scroll
    }}
  >
    {/* Header */}
    <Box
      sx={{
        backgroundColor: "#e3f2fd",
        padding: "10px",
        borderRadius: "10px",
        width:isSmallScreen ?"95%": "100%",
        textAlign: "center",
        marginBottom: "16px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: isSmallScreen? "2.1rem":"1.8rem",
          fontWeight: "bold",
          color: "#1976d2",
        }}
      >
        Booking Unavailable !!
      </Typography>
    </Box>

    {/* Message */}
    <Typography
      variant="body1"
      sx={{
        fontSize: isSmallScreen? "2rem":"1.6rem",
        color: "#555",
        marginBottom: "16px",
        lineHeight: "1.6",
        textAlign: "justify",
      }}
    >
      {dialogMessage}
    </Typography>
  </DialogContent>

  <DialogActions
    sx={{
      padding: "8px 16px",
      justifyContent: "flex-end",
      backgroundColor: "#f7f7f7",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    }}
  >
    <Button
      onClick={handleCloseDialog}
      sx={{
        fontSize: isSmallScreen? "1.7rem":"1.3rem",
        fontWeight: 600,
        padding: "8px 16px",
        backgroundColor: "#1976d2",
        color: "#fff",
        borderRadius: "5px",
        "&:hover": {
          backgroundColor: "#1565c0",
        },
      }}
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


    </>
  );
};

export default FloorMappingNew;
